module.exports = "<div>\n  <datatable [active]=\"active\" [rows]=\"formattedTransactions\" class=\"transactions\" [columns]=\"columns\"></datatable>\n</div>\n"